import { UseQueryOptions, keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { GetStatServiceRoomsDataResponseDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

export const useStatGameTypes = (rooms: string[]) => {
  const { statsControllerApi } = useApi();
  return useQuery({
    queryKey: [`/stat-game-types/fetch-game-types-data`],
    queryFn: ({ signal }) => {
      return statsControllerApi.getGameTypes({ rooms }, { signal });
    },
    placeholderData: keepPreviousData,
    enabled: !rooms.length,
  });
};
